<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Patient Case Review</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">
                Symptoms of PH1 experienced by the patient and journey to diagnosis
            </h3>

            <ul class="list-disc pl-4  font-light">
                <li>
                    A 30-year-old woman presented with <span class="font-semibold">post-partum kidney failure</span>
                </li>
                <li>
                    As the patient was born to consanguineous parents and due to the <span class="font-semibold">elevated levels of oxalate</span> identified during diagnostic investigations, PH1 was suspected
                </li>
                <li>A kidney biopsy revelated <span class="font-semibold">oxalate nephropathy</span></li>
                <li>Genetic testing was conducted to further confirm suspicions, and the patient was diagnosed  with PH1</li>
                <li>
                    The authors conclude that the acute intake of large dose of an <span class="font-semibold">oxalate-rich concoction</span> over 2 days post-partum compared with the patient’s regular diet explained the worsening of kidney function

                    <ul class="list-inside list-['-_'] pl-6">
                        <li>
                            Before the consumption of the licorice, the patient belonged to the pre-symptomatic group of patients with PH1,  which constitutes ~13% of all PH1 cases
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            This case highlights the variability in PH1 presentation; some patients may present suddenly with kidney failure after being asymptomatic as seen in this patient case
        </h3>
    </div>
</template>
